import * as Common from '@/tenant/common';

export class JournalEntry extends Common.ObjectBase{
  constructor(){
    super('JournalEntry');
    this.binders.segment = new Common.ModelBinder(Common.Segment);
  }
        public id: number = null;
        public postDate: Date = null;
        public bookDate: Date = null;
        public isExported: boolean = null;
        public slipItemNo: string = null;
        public journalType: JournalTypes = null;
        public refNo: string = null;
        public segmentId: number = null;
        public segment: Common.Segment = null;
        public segmentMappingCode: string = null;
}

export enum JournalTypes
{
  SalesCharge = 1,
  CarryOverInvoice = 2,
  AloneInvoice = 3,
  PurchaseDelivery = 4,
  PurchaseCharge = 5,
  ReceivePayment = 6,
  SendPayment = 7,
  Batch = 8,
}